import { linkpickTheme, switchThemeComponent } from '@webapps/styles';

const { params: linkpickParams } = linkpickTheme;

const {
  colors: { black2 },
  images: {
    CarrouselSign,
    PicsLogo,
    forgetPassword,
    waitingEmailConfirmation,
    Candidate,
  },
} = linkpickParams;

const defaultTheme = {
  colors: { itemColor: black2 },
  images: {
    CarrouselSign,
    PicsLogo,
    forgetPassword,
    waitingEmailConfirmation,
    Candidate,
  },
};

export default switchThemeComponent({
  default: defaultTheme,
});
